// =============================================================================
// PORTAL LAYOUT (PortalLayout.js)
// =============================================================================
// Shared page wrapper for portal pages (logos, footer, logout button).
// Adapted from cdic-portal-react/client/src/components/Layout.js
//
// KEY CHANGES:
// - Removed React Router (useNavigate) — uses onNavigate prop instead
// - All CSS class names prefixed with cdic-portal- to avoid conflicts
// =============================================================================

import React from 'react';
import { useAuth } from './PortalAuthContext';

function PortalLayout({ children, showLogout = false, onNavigate }) {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    onNavigate('login');
  };

  return (
    <div className="cdic-portal-page-wrapper">
      {showLogout && (
        <button className="cdic-portal-logout-button" onClick={handleLogout}>
          <i className="material-icons" style={{ marginRight: '4px', fontSize: '18px' }}>
            exit_to_app
          </i>
          Logout
        </button>
      )}

      <div className="cdic-portal-content-wrapper">
        <img
          src="/media/hsil_final_logo.png"
          alt="HSIL Logo"
          className="cdic-portal-logo-top"
        />

        {children}

        <img
          src="/media/cdic_logo_final.png"
          alt="Changing Diabetes in Children Logo"
          className="cdic-portal-logo-bottom"
        />
      </div>

      <footer className="cdic-portal-footer">
        Supported by an unrestricted grant from Novo Nordisk
      </footer>
    </div>
  );
}

export default PortalLayout;
